#!/usr/bin/env node

import '..';


